module.exports = __webpack_public_path__ + "media/images/logo-8b5605e1.svg";